module.exports = __webpack_public_path__ + "static/media/char.7cfe9130.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/QED/char.gif
// module id = 174
// module chunks = 0